module.exports = __webpack_public_path__ + "img/logo_ptlab.4f8d9989.png";